import { SET_SHOW_POPUP } from '../constants/ActionTypes';


export default function setShowPopup(value) {
  return {
    type: SET_SHOW_POPUP,
    payload: value
  }
}

